import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AmpFooter from "../components/common/AmpFooter/AmpFooter";
import HeaderNav from "../components/common/HeaderNav/HeaderNav";
import LanguageAccessibilty from "../components/common/LanguageAccessibility/LanguageAccessibilty";
import Logo from "../components/common/Logo/Logo";
import { useNavigate } from "react-router-dom";

import "./LandingToc.css";
import Toc from "../components/Toc/Toc";
import AmpButton from "../components/common/AmpButton/AmpButton";
import { useDispatch } from "react-redux";
import { changeModalState } from "../redux/actions/modal/modal";
import addSuperScript from "../utils/superscript";

export default function LandingToc(): JSX.Element {

    const { t } = useTranslation("landing");
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(changeModalState("modal-dismiss"));
    }, [dispatch]);

    const acceptToc = () => {
        localStorage.setItem("acceptedToc", "yes");
        window.location.reload();
    }

    const rejectToc = () => {
        navigate("/amp/signout");
    }

    return (
        <>
            <div className="landing-toc-body">
                <div className="logo-header">
                    <div className="logo-image"><Logo /></div>
                    <div className="language-accessibility-container"><LanguageAccessibilty /></div>                
                </div>
                <div className="second-header">
                    <HeaderNav isAuthed={true} pierSplash={true}></HeaderNav>
                </div>
                <div className="fake-blue-nav"/>
                <div className="landing-toc-container">
                    <div className="landing-toc"> .
                        <div className="toc-header">
                            <span>{addSuperScript(t("toc.title") as string)}</span>
                        </div>
                        <div className="toc-body-container">
                            <div className="toc-body">
                                <Toc />
                            </div>
                            <div className="toc-buttons">
                                <AmpButton type="cancel" onClick={() => rejectToc()} text={t("toc.cancel")} />
                                <AmpButton type="submit" onClick={() => acceptToc()} text={t("toc.agree")} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="landing-toc-footer">
                <AmpFooter/>
            </div>
        </>
    )
}